import { defaultInitialState, getErrorState, loadingState, updatedState } from '../utils';
import { SEND_SMS_APP_LINK, SEND_SMS_APP_LINK_DONE, SEND_SMS_APP_LINK_ERROR, RESET_SEND_SMS_APP_LINK } from './actionTypes';
const initialState = Object.assign(Object.assign({}, defaultInitialState), { data: '' });
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SEND_SMS_APP_LINK:
            return Object.assign(Object.assign(Object.assign({}, state), loadingState), { data: action.data.mobile });
        case SEND_SMS_APP_LINK_DONE:
            return Object.assign(Object.assign(Object.assign({}, state), updatedState), { data: action.data.mobile });
        case SEND_SMS_APP_LINK_ERROR:
            return Object.assign(Object.assign({}, state), getErrorState(action.errorMessage));
        case RESET_SEND_SMS_APP_LINK:
            return initialState;
        default:
            return state;
    }
};
export default reducer;
//# sourceMappingURL=reducer.js.map